export default __webpack_public_path__ + "media/images/ico-national-brand-29475a8ac4e6a186b835ac102540af2b.svg";